import {
    Module
  } from 'vuex'
  import {
    IState
  } from '../../..'
  import {
    RephraseActions
  } from './actions'
  import {
    RephraseGetters
  } from './getters'
  import {
    IRephraseState,
    RephraseState
  } from './state'
  import {
    RephraseMutations
  } from './mutations'
  
  export const rephrase: Module < IRephraseState, IState > = {
    namespaced: true,
    actions: {
      ...RephraseActions
    },
    getters: {
      ...RephraseGetters
    },
    state: {
      ...RephraseState()
    },
    mutations: {
      ...RephraseMutations
    },
  }